<template>
  <div>
    <el-input
      clearable
      v-model="value"
      :placeholder="'请输入' + config.cnName"
    ></el-input>
  </div>
</template>
<script>
export default {
  props: ["data", "config"],
  computed: {
    value: {
      get() {
        return this.data;
      },
      set(val) {
        this.$emit("update:data", val);
      },
    },
  },
};
</script>
